import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthenticationContext } from "../App";
import { useContext } from "react";
import { HasPermission } from "./constants";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
    let location = useLocation();
    const authData = useSelector((state) => state.auth?.authData);
    const authInfo = useSelector((state) => state.auth);
    const Permissions = authData?.permissions?.map((it) => it.submodules).flat();
    //console.log("PROTECTE", location.pathname, authInfo.token, HasPermission(location.pathname, Permissions, false))
    if (authInfo.token && HasPermission(location.pathname, Permissions, false)) {
        return children;
    } else {
        if (authInfo.token) {
            return <Navigate to="/no-permission" />;
        } else {
            return <Navigate to="/login" />;
        }
    }
};

export default ProtectedRoute;
